export default "__VITE_ASSET__CChxz9fz__"